import { render } from "./TopTextBox.vue?vue&type=template&id=5d2e6ca2&scoped=true"
import script from "./TopTextBox.vue?vue&type=script&lang=js"
export * from "./TopTextBox.vue?vue&type=script&lang=js"

import "./TopTextBox.vue?vue&type=style&index=0&id=5d2e6ca2&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2e6ca2"]])

export default __exports__